import { apiInstance } from "@/api/api.js"
const api = apiInstance()

export default {
  async getDictionaries ({ commit, dispatch }) {
    try {
      await Promise.all([
        api.get('/dictionaries/bh_user_role'),
        api.get('/dictionaries/practice_user_role'),
        api.get('/dictionaries/file_type'),
        api.get('file/supported'),
        api.get('dictionaries/feature_flag_state'),
        api.get('/dictionaries/auditable-operations'),
        api.get('/dictionaries/auditable-types'),
      ]).then(([
          bh_user_role,
          practice_user_role,
          file_types,
          supported_file_types,
          feature_flag_state,
          auditable_operations,
          auditable_types
        ]) => {
          commit('setBhUserRoleIds', bh_user_role.data.dictionaryItems)
          commit('setPracticeUserRole', practice_user_role.data.dictionaryItems)
          commit('setFileTypes', file_types.data.dictionaryItems)
          commit('setSupportedFileTypes', supported_file_types.data)
          commit('setFeatureFlagState', feature_flag_state.data.dictionaryItems)
          commit('setAuditableOperations', auditable_operations.data.dictionaryItems)
          commit('setAuditableTypes', auditable_types.data.dictionaryItems)
          commit('setDictionariesLoaded')
        })
    }
    catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
    }
  }
}
